/**
 * @file: ProductReferralFeeItemOwnerType.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum ProductReferralFeeItemOwnerType {
  Referrer = 'referrer',
  Adopter = 'adopter',
  Closer = 'closer',
}

export const ProductReferralFeeItemOwnerTypeValueSet = new Set([
  ProductReferralFeeItemOwnerType.Referrer,
  ProductReferralFeeItemOwnerType.Adopter,
  ProductReferralFeeItemOwnerType.Closer,
]);
